import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-payments-prov',
  templateUrl: './payments-prov.component.html',
  styleUrls: ['./payments-prov.component.scss']
})
export class PaymentsProvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/payments-prov/payments-prov.component.ts